export default {
  MENU_ITEM_LOAD: 'MENU_ITEM_LOAD',
  MENU_ITEM_LOAD_STATS: 'MENU_ITEM_LOAD_STATS',
  MENU_ITEM_COMPLETE: 'MENU_ITEM_COMPLETE',
  MENU_ITEM_CREATE: 'MENU_ITEM_CREATE',
  MENU_ITEM_SAVE: 'MENU_ITEM_SAVE',
  MENU_ITEM_DELETE: 'MENU_ITEM_DELETE',
};


// WEBPACK FOOTER //
// ./modules/menu/constants/MenuItemConstants.js